import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=576e2bf6&scoped=true&"
import script from "./ServiceDetail.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=576e2bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e2bf6",
  null
  
)

export default component.exports